module.exports = __webpack_public_path__ + "img/inheritance_2.53eb010f.png";